export default __webpack_public_path__ + "static/media/ai-article.1d44931e.svg";